/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  IconFormatBoldMS,
  IconFormatH1MS,
  IconFormatH2MS,
  IconFormatItalicMS,
  IconFormatListBulletedMS,
  IconFormatListNumberedMS,
} from '../../../../../../../constants/icons';
import {
  ButtonsContainer,
  MenuContainer,
  StyledHeadIconButton,
  StyledIconButton,
} from './styles';

interface RichTextMenuProps {
  editor: any;
}

export function RichTextMenu({
  editor,
}: RichTextMenuProps): JSX.Element | null {
  return (
    <MenuContainer>
      <ButtonsContainer>
        <StyledIconButton
          disableTouchRipple
          onClick={() => editor.chain().focus().toggleBold().run()}
          disabled={!editor.can().chain().focus().toggleBold().run()}
          selected={editor.isActive('bold')}
          sx={{
            span: {
              fontWeight: '600',
            },
          }}
        >
          {IconFormatBoldMS}
        </StyledIconButton>
        <StyledIconButton
          disableTouchRipple
          onClick={() => editor.chain().focus().toggleItalic().run()}
          disabled={!editor.can().chain().focus().toggleItalic().run()}
          selected={editor.isActive('italic')}
        >
          {IconFormatItalicMS}
        </StyledIconButton>
        <StyledIconButton
          disableTouchRipple
          onClick={() => editor.chain().focus().toggleBulletList().run()}
          disabled={!editor.can().chain().focus().toggleBulletList().run()}
          selected={editor.isActive('bulletList')}
        >
          {IconFormatListBulletedMS}
        </StyledIconButton>
        <StyledIconButton
          disableTouchRipple
          onClick={() => editor.chain().focus().toggleOrderedList().run()}
          disabled={!editor.can().chain().focus().toggleOrderedList().run()}
          selected={editor.isActive('orderedList')}
        >
          {IconFormatListNumberedMS}
        </StyledIconButton>
        <StyledHeadIconButton
          disableTouchRipple
          onClick={() =>
            editor.chain().focus().toggleHeading({ level: 2 }).run()
          }
          disabled={
            !editor.can().chain().focus().toggleHeading({ level: 2 }).run()
          }
          selected={editor.isActive('heading', { level: 2 })}
        >
          {IconFormatH1MS}
        </StyledHeadIconButton>
        <StyledHeadIconButton
          disableTouchRipple
          onClick={() =>
            editor.chain().focus().toggleHeading({ level: 3 }).run()
          }
          disabled={
            !editor.can().chain().focus().toggleHeading({ level: 3 }).run()
          }
          selected={editor.isActive('heading', { level: 3 })}
        >
          {IconFormatH2MS}
        </StyledHeadIconButton>
      </ButtonsContainer>
    </MenuContainer>
  );
}
